module.exports = __webpack_public_path__ + "static/media/ico-location.bd58604a.svg";